/*Это технология для передачи данных, минуя промежуточные компоненты*/

import Vue from 'vue';
export const eventBus = new Vue();